const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-db273b1a-9500-44d5-be09-9c14eb9664df {\n        fill: #5e3524;\n      }\n\n      .uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea, .uuid-b44efbab-73ee-4730-885c-079f533feed1 {\n        fill: none;\n        stroke: #e8e4db;\n        stroke-linejoin: round;\n      }\n\n      .uuid-b44efbab-73ee-4730-885c-079f533feed1 {\n        stroke-width: 2px;\n      }\n    "));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-450ff0fc-95d0-4a70-9ae6-7f6f8482bd06",
  "data-name": "Circles"
}, /*#__PURE__*/React.createElement("circle", {
  className: "uuid-db273b1a-9500-44d5-be09-9c14eb9664df",
  cx: 22,
  cy: 21.95,
  r: 22
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "uuid-b07b8958-5456-44bc-ad7e-b2d74bd57c75",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("polyline", {
  className: "uuid-b44efbab-73ee-4730-885c-079f533feed1",
  points: "22 13.21 25.13 16.44 28.82 25.36 28.82 32.92"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "uuid-b44efbab-73ee-4730-885c-079f533feed1",
  points: "22 13.21 18.84 16.44 15.15 25.36 15.15 32.92"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  d: "M22.07,35.98l13.61-6.18c.06-.03.1-.09.1-.16v-7.19c0-.13-.13-.21-.25-.16-1.77.8-12.55,5.7-13.49,6.12-.05.02-.09.02-.14,0l-13.47-6.12c-.12-.05-.25.03-.25.16v7.19c0,.07.04.13.1.16,1.18.54,12.59,5.72,13.63,6.18.05.02.1.02.14,0Z"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  x1: 21.98,
  y1: 28.44,
  x2: 21.98,
  y2: 36.02
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b44efbab-73ee-4730-885c-079f533feed1",
  d: "M22,13.21s.38-4.22,5.05-4.63c.49-.04.95.28,1.05.77.23,1.19-.21,3.36-6.09,3.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-b44efbab-73ee-4730-885c-079f533feed1",
  d: "M22,13.21s-.38-4.22-5.05-4.63c-.49-.04-.95.28-1.05.77-.23,1.19.21,3.36,6.09,3.87Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  d: "M22.06,17.7c.66-.29,5.52-2.47,6.67-2.99.12-.05.24.03.24.16v6.59c0,.07-.04.13-.1.16-.81.37-6.16,2.77-6.82,3.06-.05.02-.09.02-.14,0l-6.8-3.05c-.06-.03-.1-.09-.1-.16v-6.59c0-.13.13-.21.25-.16,1.16.52,6.05,2.72,6.67,2.99.05.02.09.02.13,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  d: "M21.98,17.73s0,6.97.02,6.97"
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  x1: 8.27,
  y1: 22.31,
  x2: 15.01,
  y2: 19.04
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  x1: 35.69,
  y1: 22.29,
  x2: 28.97,
  y2: 19.04
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  x1: 15.08,
  y1: 14.73,
  x2: 19.19,
  y2: 12.75
}), /*#__PURE__*/React.createElement("line", {
  className: "uuid-d3f5de98-926d-4a6f-9dd4-eaf9fb2ddbea",
  x1: 28.92,
  y1: 14.73,
  x2: 24.81,
  y2: 12.75
}));
function SvgRepozeIconCategoryBundles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepozeIconCategoryBundles);
export default __webpack_public_path__ + "static/media/repoze_icon_category-bundles.d67776a9ec36d1e13b04fb1d5228b872.svg";
export { ForwardRef as ReactComponent };